<template>
  <svg
    :width="width"
    viewBox="0 0 7 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 11.5L6 6.5L1 1.5"
      :stroke="fill"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
  export default {
    name: 'RightArrowIcon',
    props: {
      width: {
        type: Number,
        default: 7,
      },
      fill: {
        type: String,
        default: '#333333',
      },
    },
  }
</script>

<style>

</style>
